import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-therapie',
  templateUrl: './therapie.component.html',
  styleUrls: ['./therapie.component.scss']
})
export class TherapieComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
